import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo_eagle from "../assets/img/logo_eagle.png";
import "./components.css";

/** Explore links, filtered by section-level visibility — see the Footer body. */
const EXPLORE = [
    { id: "updates", to: "/updates", label: "Updates" },
    { id: "blog", to: "/blog", label: "Blog" },
    { id: "policies", to: "/policies", label: "Policies" },
];

const Footer = () => {
    const { isSectionVisible } = useAuth();

    /**
     * A section closed to this viewer must not be linked here either. The footer is on
     * EVERY page, so leaving these would keep advertising a section the nav and the home
     * teasers deliberately hide — and the link would land on a 404.
     */
    const explore = EXPLORE.filter((item) => isSectionVisible(item.id));

    return (
    <footer className="site-footer">
        <div className="page-wrap">
            <div className="footer-grid">
                <div className="footer-brand">
                    <span className="brand">
                        <img src={logo_eagle} alt="" className="brand-logo" />
                        <span className="brand-text">Dolluz Corp<span className="brand-dot">.</span></span>
                    </span>
                    <p className="footer-about">
                        An integrated ecosystem of enterprise applications - built in-house to
                        streamline how our teams work, from HR to engineering.
                    </p>
                </div>

                {/* Drop the whole column when nothing in it is visible, rather than
                    leaving an "Explore" heading over an empty list. */}
                {explore.length > 0 && (
                    <div className="footer-col">
                        <h3>Explore</h3>
                        <ul>
                            {explore.map((item) => (
                                <li key={item.id}><Link to={item.to}>{item.label}</Link></li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="footer-col">
                    <h3>Company</h3>
                    <ul>
                        <li>
                            <a href="https://www.dolluzcorp.com" target="_blank" rel="noopener noreferrer">
                                dolluzcorp.com
                            </a>
                        </li>
                        <li><a href="mailto:admin@dolluzcorp.com">admin@dolluzcorp.com</a></li>
                    </ul>
                </div>
            </div>

            <div className="footer-wordmark" aria-hidden="true">Dolluz Corp</div>

            <div className="footer-bottom">
                <span>© {new Date().getFullYear()} Dolluz Corp. All rights reserved.</span>
                <span>HIPAA · ISO 9001:2015 · ISO 27001:2013</span>
            </div>
        </div>
    </footer>
    );
};

export default Footer;
